import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { currency } from '@ecg-marktplaats/aurora-js-formatters';
import { VerticalListing, BlockLink } from '@hz-design-system/web-ui';

import TListing from '../../types/TListing';

type TProps = {
  listing: TListing;
  onClick?: () => void;
};

// TODO: get right image size from API
const transformImageSize = (imageUrl) => (imageUrl.indexOf('$_82') > -1 ? imageUrl.replace('$_82', '$_83') : imageUrl);

const Listing = ({ listing, onClick }: TProps) => {
  const hasImage = listing.imageUrls && listing.imageUrls.length;
  const imageSrc = hasImage ? transformImageSize(listing.imageUrls[0]) : '';

  const { priceCents, priceType } = listing.priceInfo;
  const { t } = useI18nContext();
  const hasMonetaryValue = priceType === 'MIN_BID' || priceType === 'FIXED';
  const formattedPrice = hasMonetaryValue ? currency(priceCents, true) : t(`prices:prices.${priceType}`);

  return (
    <BlockLink href={listing.vipUrl || `/link/ad/${listing.itemId}`} onClick={onClick}>
      <VerticalListing title={listing.title} price={formattedPrice} imageSrc={imageSrc} />
    </BlockLink>
  );
};

export default Listing;
